import $ from 'jquery'

export function initAudio(el) {
  $(el).each((index, audio) => {
    setTimeout(() => { _initAudio(audio) }, 0)
  })
}

function _initAudio(audioEl) {
  const $audio = $(audioEl);
  const audioId = $audio[0].dataset.eventLabel;

  _audioEventsListners($audio, audioId);
  _impressionEvent(audioId);
}


function _audioEventsListners(el, id) {
  const $audio = $(el);
  let audioConditions = {
    wasFiftyReached: false,
    audioStarted: false,
    audioEnded: false
  };

  $audio.on('play', (e) => {
    const $target = $(e.target)
    const audioId = $target.attr('id')

    _stickyPlayer(e, audioId)

    $('audio').not('#' + audioId).trigger('pause')// pause all other audios when play

    $('.audio-playing').removeClass('audio-playing')
    $target.addClass('audio-playing')

    if (!audioConditions.audioStarted) {
      audioConditions.audioStarted = true;
      _playEventHandler(id);
    }

    if (!audioConditions.wasFiftyReached) {
      // Starting counter for Triggering of 50% Event
      const percentCounter = setInterval(function() {
        var viewedPercentage = Math.round((($audio[0].currentTime / $audio[0].duration) * 100));

        if (viewedPercentage >= 50) {
          audioConditions.wasFiftyReached = true;
          _audioHalfListned(id);
          clearInterval(percentCounter);
        }
      }, 500);

      $audio.on('pause', () => {
        clearInterval(percentCounter);
      });
    }
  });

  $audio.on('ended', () => {
    $(window).off('scroll.stickyaudio')
    $('.fixed-audio').removeClass('fixed-audio')
    $('.audio-playing').removeClass('audio-playing')

    if (!audioConditions.audioEnded) {
      audioConditions.audioEnded = true;
      _audioListenedFully(id);
    }
  })
}

function _stickyPlayer(e, audioId) {
  const $target = $(e.target)

  if ($('.editable-section').length == 0) { // for all tutorials (free, spcc areas) except author role
    $('audio').not('#' + audioId).parent().removeClass('fixed-audio')

    // remove sticky for other audios
    $(window).off('scroll.stickyaudio')
  }

  if ($('body.tutorial-page').length < 1) { // all tutorials except free SOPHIA
    $(window).on('scroll.stickyaudio', function() {
      _fixAudioPlayer($target, _fixedHeaderHeight())
    })

    $('.assessment-two-cols__right').on('scroll.stickyaudio', function() {
      _fixAudioPlayer($target, _fixedHeaderHeight())
    })
  }

  $(window).on('resize', function() {
    if ($('body.tutorial-page').length < 1) { // all tutorials except free SOPHIA
      const $audioWrapper = $target.parents('.playerWrapper')
      const playerWidth = $audioWrapper.width()

      $('.fixed-audio').css({ 'width': playerWidth });
    }
  })
}

function _fixAudioPlayer($target, headerHeight) {
  const $audioPlayer = $target.parent()
  const $audioWrapper = $target.parents('.playerWrapper')
  const windowTop = parseInt( $(window).scrollTop(), 10 )
  const audioWrapperOffset = $audioWrapper.offset().top
  const playerWidth = $audioWrapper.width()
  const playerHeight = $audioPlayer.height()
  const $section = $target.parents('.section')
  const sectionWidth = $section.width()
  const leftPosition = $section.offset().left

  $audioWrapper.css({ 'min-height' : playerHeight}); // to prevent jumping

  if (windowTop - audioWrapperOffset + headerHeight > 0) {
    if ( !$audioPlayer.hasClass('fixed-audio') ) {
      // set class
      if ($target.hasClass('audio-playing')) {
        $audioPlayer.addClass('fixed-audio');
      }

      // set padding to container
      $('.fixed-audio').css({ 'top' : headerHeight, 'left' : leftPosition, 'width': sectionWidth});
    }
  } else {
    if ( $audioPlayer.hasClass('fixed-audio') ) {
      // remove class
      $audioPlayer.removeClass('fixed-audio').css({ 'width': playerWidth});
    }
  }
}

function _fixedHeaderHeight() {
  let $fixedHeader
  let headerHeight

  if ($('.common-fullwidth-header.stuck-header').length) { // study guide
    $fixedHeader = $('.common-fullwidth-header')
    headerHeight = parseInt($fixedHeader.outerHeight(), 10)
  } else if ($('.assessment-fullwidth-header').length) { // assessment area
    if ($('.challenge-take-page.challenge-one').length) { // challenge 1.0 page
      const height1 = $('.flexible-assessment-header-sticky').height()
      const height2 = $('.assessment-take__main-nav__wrapper').height()

      if ($('.flexible-assessment-header-sticky.stuck-header').length) { // 2-column
        headerHeight = height1 + height2
      } else { // 1-column
        headerHeight = height2
      }

    } else { // not challenge 1.0

      if ($('.is-stuck.assessment-take__main-nav__wrapper').length) { // 1-column
        $fixedHeader = $('.is-stuck.assessment-take__main-nav__wrapper')
      } else { // 2-column
        $fixedHeader = $('.assessment-fullwidth-header')
      }

      headerHeight = parseInt($fixedHeader.outerHeight(), 10)
    }
  } else {
    headerHeight = 0
  }

  return headerHeight
}

function _impressionEvent(id) {
  _gaEvent('Audio-player', 'Impression', id);
  _snowplowEvent('Audio-player', 'Impression', id);
}

function _audioHalfListned(id) {
  _gaEvent('Audio-player', 'Listened-50', id);
  _snowplowEvent('Audio-player', 'Listened-50', id);
}

function _playEventHandler(id) {
  _gaEvent('Audio-player', 'Play', id);
  _snowplowEvent('Audio-player', 'Play', id);
}

function _audioListenedFully(id) {
  _gaEvent('Audio-player', 'Complete', id);
  _snowplowEvent('Audio-player', 'Complete', id);
}

function _gaEvent(category, action, label) {
  ga('send', 'event', category, action, label);
}

function _snowplowEvent(category, action, label) {
  snowplow('trackStructEvent', {
    category,
    action,
    label
  });
}
